import { useState, useMemo, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import PageWrapper from "../components/PageWrapper";
import { createPortal } from "react-dom";

export default function MutasiMasuk() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("ALL");
  const [openMenu, setOpenMenu] = useState(null);
const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
const [isLoadingReturn, setIsLoadingReturn] = useState(false);

const [scanReceiveModal, setScanReceiveModal] = useState(false);
const [scanReceiveInput, setScanReceiveInput] = useState("");
const scanReceiveRef = useRef(null);

const [skuModal, setSkuModal] = useState(false);
const [skuItem, setSkuItem] = useState(null);
const [skuInput, setSkuInput] = useState("");

const [uniqModal, setUniqModal] = useState(false);
const [scanItem, setScanItem] = useState(null);
const [uniqInput, setUniqInput] = useState("");


const [menuRef, setMenuRef] = useState(null);
  const [shippingModal, setShippingModal] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [toast, setToast] = useState(null);

const [detailModal, setDetailModal] = useState(false);
const [orderDetail, setOrderDetail] = useState([]);
const [loadingDetail, setLoadingDetail] = useState(false);

const [selectedItems, setSelectedItems] = useState([]);
const [groupMode, setGroupMode] = useState("uniq"); // uniq | group
const [scanResult, setScanResult] = useState([]);
const [scanSummary, setScanSummary] = useState({
  total: 0,
  scanned: 0,
  remaining: 0,
  status: "BELUM SESUAI",
});

// bikin helper
const isBelumPosting =
  selectedRow?.status === "BELUM POSTING";
// GROUPING
const groupedData =
  groupMode === "group"
    ? Object.values(
        orderDetail.reduce((acc, item) => {
          const key = `${item.kode_extend}_${item.ukuran}`;

          if (!acc[key]) {
            acc[key] = {
              kode_extend: item.kode_extend,
              ukuran: item.ukuran,
              qty: 0,
              items: [],
            };
          }

          acc[key].qty += 1;
          acc[key].items.push(item);

          return acc;
        }, {})
      )
    : [];

// CHECK SINGLE
const toggleItem = (uniq_id) => {
  setSelectedItems((prev) =>
    prev.includes(uniq_id)
      ? prev.filter((x) => x !== uniq_id)
      : [...prev, uniq_id]
  );
};

// CHECK ALL
const toggleAll = () => {
  if (selectedItems.length === orderDetail.length) {
    setSelectedItems([]);
  } else {
    setSelectedItems(orderDetail.map((x) => x.uniq_id));
  }
};

const showToast = (message, type = "success") => {
  setToast({ message, type });

  setTimeout(() => {
    setToast(null);
  }, 3000);
};

const handleReturnToOrigin = (item) => {
  // 1. Validasi awal memastikan ID Koli aktif tersedia
  const currentKoliId = selectedRow?.id_mutasi_toko;

  if (!currentKoliId) {
    showToast("ID Koli aktif tidak ditemukan", "error");
    return;
  }

  // 2. Tampilkan konfirmasi terlebih dahulu SEBELUM mengubah state loading
  const konfirmasi = window.confirm(
    `Apakah Anda yakin ingin mengembalikan 1 pcs artikel ${item.kode_extend} ke toko asal?`
  );
  
  // Jika operator memilih 'Cancel', langsung keluar tanpa mengunci tombol
  if (!konfirmasi) return;

  // 3. Nyalakan loading HANYA setelah operator setuju (mengklik 'OK')
  setIsLoadingReturn(true);

  // 4. Kirim request ke backend
  axios.post("/api/warehouse/kembalikan-scan-mutasi-md", {
    id_det: item.id || item.id_det, 
    uniq_koli_id: currentKoliId,
    id_sunfish: localStorage.getItem("id_sunfish"), 
    kode_toko: localStorage.getItem("kode_toko")  
  })
  .then((res) => {
    if (res.data.success) {
      showToast(`1 pcs ${item.kode_extend} berhasil dikembalikan ke list asal`, "success");
      
      // Refresh data di layar
      if (typeof fetchData === "function") fetchData();
      if (typeof fetchScanDetail === "function") fetchScanDetail(currentKoliId);
    }
  })
  .catch((err) => {
    console.error("RETURN ITEM ERROR:", err);
    showToast(
      err?.response?.data?.message || "Gagal mengembalikan barang ke toko asal", 
      "error"
    );
  })
  .finally(() => {
    // 5. Apapun hasilnya (sukses/gagal), pastikan loading dimatikan di sini
    setIsLoadingReturn(false);
  });
};

const fetchScanDetail = async (id_mutasi_toko) => {
  try {
     const id_sunfish = localStorage.getItem("id_sunfish");
      const kode_toko = localStorage.getItem("kode_toko");
    const res = await axios.get(
      "/api/warehouse/scan-penerimaan-detail",
      {
        params: { id_mutasi_toko,id_sunfish,kode_toko },
      }
    );

    const sorted = (res.data.items || []).sort((a, b) => {
      const aScanned = a.is_scanned ? 1 : 0;
      const bScanned = b.is_scanned ? 1 : 0;

      return bScanned - aScanned; // scanned di atas
    });

    setScanResult(sorted);

    setScanSummary({
      total: res.data.total || 0,
      scanned: res.data.scanned || 0,
      remaining: res.data.remaining || 0,
      status: res.data.status || "BELUM SESUAI",
    });

  } catch (err) {
    console.error(err);
  }
};


const [form, setForm] = useState({
  shipping_type: "TIKTOK", // 🔥 NEW
  handover_method: "PICKUP",
  pickup_slot_start: "",
  pickup_slot_end: "",
  shipping_provider: "",
  tracking_number: "",
});

const isValidSku = (sku) => {
  return /^\d{11}$/.test(sku); // hanya 11 digit angka
};


 const fetchData = async () => {
      try {
        const kode_toko = localStorage.getItem("kode_toko");
        const id_sunfish = localStorage.getItem("id_sunfish");

        const res = await axios.get("/api/warehouse/inbound-mutation", {
          params: { kode_toko,id_sunfish },
        });

        setData(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

  // ===== FETCH =====
  useEffect(() => {
   
    fetchData();
  }, []);

  // ===== OUTSIDE CLICK =====
  useEffect(() => {
  const handleClickOutside = (e) => {
  // kalau klik di dalam menu / tombol → jangan close
  if (menuRef?.contains?.(e.target)) return;
  setOpenMenu(null);
};

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);


const TableLoading = () => {
  return (
    <div className="p-4 space-y-3 animate-pulse">
      
      {[1,2,3,4,5,6].map((i) => (
        <div
          key={i}
          className="grid grid-cols-7 gap-4 items-center py-3"
        >

          {/* ID Surat Jalan */}
          <div className="h-5 bg-gray-200 rounded-lg col-span-1 w-[180px]" />

          {/* Tanggal */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[120px]" />

          {/* User */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[100px]" />

          {/* Status badge */}
          <div className="h-6 bg-gray-200 rounded-full col-span-1 w-[90px]" />

          {/* Jenis Inbound */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[110px]" />

          {/* Total Qty */}
          <div className="h-4 bg-gray-200 rounded col-span-1 w-[70px]" />

          {/* Total HJP + action (digabung kanan) */}
          <div className="flex justify-end gap-2 col-span-1">

            <div className="h-4 w-[90px] bg-gray-200 rounded" />

            <div className="h-8 w-8 bg-gray-200 rounded-lg" />

          </div>

        </div>
      ))}

    </div>
  );
};

  // ===== FORMAT DATE =====
  const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};


const getMinDateTime = () => {
  const now = new Date();

  // convert ke WIB (UTC+7)
  const wibOffset = 7 * 60;
  const localOffset = now.getTimezoneOffset();
  const wibTime = new Date(now.getTime() + (wibOffset + localOffset) * 60000);

  return wibTime.toISOString().slice(0, 16);
};

const getMaxDateTime = () => {
  const now = new Date();

  const wibOffset = 7 * 60;
  const localOffset = now.getTimezoneOffset();
  const wibTime = new Date(now.getTime() + (wibOffset + localOffset) * 60000);

  wibTime.setDate(wibTime.getDate() + 2); // 🔥 hanya 2 hari ke depan

  return wibTime.toISOString().slice(0, 16);
};

const normalizeUniqId = (value) => {
  if (!value) return "";

  const clean = value.trim();

  // ambil hash stable dari bagian awal (lebih aman daripada slice)
  return clean.substring(0, 11);
};


const getSLAStatus = (row) => {
  if (!row?.shipping_due_time) return "SAFE";

  const status = (row.status || "").toUpperCase();

  const SLA_STATUSES = [
    "AWAITING_COLLECTION",
    "BELUM POSTING",
  ];

  if (!SLA_STATUSES.includes(status)) return "SAFE";

  const now = Date.now();
  const due = new Date(row.shipping_due_time).getTime();

  if (isNaN(due)) return "SAFE"; // 🔥 guard kalau date rusak

  const diffMs = due - now;
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffMs < 0) return "OVERDUE";
  if (diffHours < 6) return "WARNING";

  return "SAFE";
};

const getRowColor = (item) => {
  const received = item.qty_received || 0;
  const total = item.qty || 0;

  if (received === 0) return "bg-white";
  if (received < total) return "bg-yellow-50 border-yellow-200";
  if (received >= total) return "bg-green-50 border-green-200";

  return "bg-white";
};

  // ===== STATUS TABS =====
  const statusTabs = useMemo(() => {
    const map = {};

    data.forEach((d) => {
      const s = d.status || "UNKNOWN";
      map[s] = (map[s] || 0) + 1;
    });

    return [
      { label: "All", value: "ALL", count: data.length },
      ...Object.keys(map).map((key) => ({
        label: key.replaceAll("_", " "),
        value: key,
        count: map[key],
      })),
    ];
  }, [data]);

  // ===== FILTER =====
  const filteredData = data.filter((item) => {
    const keyword = search.toLowerCase();

    const matchSearch =
      item.id_mutasi_toko?.toLowerCase().includes(keyword)||
      item.toko_asal?.toLowerCase().includes(keyword);

    const matchTab =
      activeTab === "ALL" || item.status === activeTab;

    return matchSearch && matchTab;
  });

  // ===== STATUS BADGE =====
  const getStatusColor = (status) => {
    const s = status?.toUpperCase();

    if (s === "SUDAH POSTING")
      return "bg-green-100 text-green-700";
    if (s === "PICKUP")
      return "bg-emerald-100 text-emerald-700";
    if (s === "IN_TRANSIT")
      return "bg-blue-100 text-blue-700";
    if (s === "PAID")
      return "bg-yellow-100 text-yellow-700";
    if (s === "AWAITING_COLLECTION")
      return "bg-purple-100 text-purple-700";
    if (s === "BELUM POSTING" || s === "CANCEL")
      return "bg-red-100 text-red-700";

    return "bg-gray-100 text-gray-600";
  };

  

  const isDisabled =
  form.shipping_type === "SELF"
    ? !form.shipping_provider_id || !form.tracking_number
    : form.handover_method === "PICKUP" &&
      (!form.pickup_slot_start || !form.pickup_slot_end);


  // ===== ACTION =====
const handleAction = (type, row) => {
 if (type === "detail") {
   setSelectedRow(row); // 🔥 INI YANG KURANG
  setDetailModal(true);
  setLoadingDetail(true);
  const kode_toko = localStorage.getItem("kode_toko");
 const id_sunfish = localStorage.getItem("id_sunfish");
  axios
    .get("/api/warehouse/inbound-mutation-details", {
      params: { id_mutasi_toko: row.id_mutasi_toko,kode_toko_asal: row.kode_toko_asal,kode_toko,id_sunfish },
    })
    .then((res) => {
      setOrderDetail(res.data.data);
    })
    .finally(() => setLoadingDetail(false));
}

if (type === "scan_penerimaan") {
  setSelectedRow(row);
  setScanReceiveModal(true);

  fetchScanDetail(row.id_mutasi_toko);

  setTimeout(() => {
    scanReceiveRef.current?.focus();
  }, 200);

  setOpenMenu(null);
}

  if (type === "invoice") {
    window.open(`/invoice/${row.id_mutasi_toko}`, "_blank");
  }

  if (type === "shipping") {
    if (!row.doc_url) {
      alert("Shipping label belum tersedia");
      return;
    }

    window.open(row.doc_url, "_blank", "noopener,noreferrer");
  }

 if (type === "arrange_shipping") {
  setSelectedRow(row);
  setShippingModal(true);

  setForm({
    handover_method: "PICKUP",
    pickup_slot_start: "",
    pickup_slot_end: "",
  });
}

  setOpenMenu(null);
};




  // ===== COLUMNS =====
  const columns = [
    {
      name: "ID Mutasi",
      minWidth: "220px",
      cell: (row) => (
        <div className="py-3">
          <div className="font-semibold text-gray-900">
            {row.id_mutasi_toko}
          </div>
        </div>
      ),
    },
    {
  name: "Tanggal",
  cell: (row) => {
    const date = row.tanggal ? new Date(row.tanggal) : null;

    return (
      <div className="text-sm text-gray-500">
        {date
          ? date.toLocaleDateString("id-ID", {
              year: "numeric",
              month: "short",
              day: "2-digit",
            })
          : "-"}
      </div>
    );
  },
},
    {
      name: "Toko Asal",
      cell: (row) => (
        <div className="py-2">
          <div className="font-medium text-gray-900">
            {row.toko_asal}
          </div>
          
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        
        <span
          className={`px-3 py-1 text-xs rounded-full font-medium ${
            getStatusColor(
            row.status.toUpperCase()
          )}`}
        >
          {row.status.toUpperCase()}
        </span>
      ),
    },
    
    {
      name: "Jenis Mutasi",
      selector: (row) => row.keperluan || "-",
    },
   
   
     {
  name: "Total Qty",
  selector: (row) =>
    new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
    }).format(row.qty || 0),
},
   {
  name: "Diterima",
  selector: (row) =>
    new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
    }).format(row.qty_received || 0),
},
    {
      name: "",
      width: "60px",
      cell: (row) => (
        <div  ref={menuRef}>
         <button
  onClick={(e) => {
    
    const rect = e.currentTarget.getBoundingClientRect();

    const dropdownWidth = 160;
    const dropdownHeight = 120;

    let x = rect.right;
    let y = rect.bottom;

    if (x > window.innerWidth) {
      x = window.innerWidth - dropdownWidth - 10;
    }

    if (y + dropdownHeight > window.innerHeight) {
      y = rect.top - dropdownHeight;
    }

    setMenuPosition({ x, y });
    setOpenMenu(openMenu === row.id_mutasi_toko ? null : row.id_mutasi_toko);
  }}
  className="p-2 rounded-lg hover:bg-gray-100 transition"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5 text-gray-600"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="5" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="12" cy="19" r="2" />
  </svg>
</button>

       {openMenu === row.id_mutasi_toko &&
  createPortal(
    <div
      className="fixed w-40 bg-white border rounded-lg shadow-lg z-[99999]"
      style={{
        top: menuPosition.y,
        left: menuPosition.x - 160,
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
    

      <button
        onClick={() => handleAction("detail", row)}
        className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
      >
        View Detail
      </button>

      <button
  onClick={() => handleAction("scan_penerimaan", row)}
  className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
>
  Scan Penerimaan
</button>

     

     
    </div>,
    document.body
  )
}
        </div>
      ),
    },
  ];

const customStyles = {
  tableWrapper: {
    style: {
      overflow: "visible",
    },
  },
 table: {
  style: {
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    overflow: "hidden",
  },
},
  headRow: {
    style: {
      overflow: "visible",
    },
  },
rows: {
  style: (row) => {
    const sla = getSLAStatus(row);

    return {
      backgroundColor:
        sla === "OVERDUE"
          ? "#fee2e2"
          : sla === "WARNING"
          ? "#ffedd5"
          : "transparent",
      borderLeft:
        sla === "OVERDUE"
          ? "4px solid #dc2626"
          : sla === "WARNING"
          ? "4px solid #f97316"
          : "none",
          borderBottom: "1px solid #e5e7eb",
    };
  },
},
  cells: {
    style: {
      overflow: "visible",
    },
  },
  headCells: {
    style: {
      fontSize: "12px",
      fontWeight: "600",
      backgroundColor: "#f9fafb",
    },
  },
};

  return (
    <PageWrapper>
      {toast && (
  <div
    className={`fixed top-5 right-5 px-4 py-3 rounded-lg shadow-lg text-white z-[1000000]
      ${toast.type === "success" ? "bg-green-600" : "bg-red-600"}
    `}
  >
    {toast.message}
  </div>
)}
      <div className="space-y-5">

        {/* HEADER */}
        <div>
          <h1 className="text-xl font-semibold text-gray-800">
            Surat Jalan Mutasi Masuk
          </h1>
          <p className="text-sm text-gray-500">
            Real-time order monitoring & Surat Jalan Mutasi Masuk
          </p>
        </div>

        {/* TABS */}
        {/* TABS */}
<div className="flex gap-3 flex-wrap bg-gray-50 p-2 rounded-2xl border">

 {statusTabs.map((tab) => {
  const isActive = activeTab === tab.value;
  const isSLA = tab.value === "BELUM POSTING";

  return (
    <button
      key={tab.value}
      onClick={() => setActiveTab(tab.value)}
      className={`flex items-center gap-2 px-5 py-3 rounded-xl border transition font-medium

        ${
          isActive
            ? isSLA
              ? "bg-red-600 text-white shadow-md"   // 🔥 aktif + SLA
              : "bg-gray-900 text-white shadow-md"
            : isSLA
              ? "bg-red-50 text-red-600 border-red-200 hover:bg-red-100" // 🔥 non aktif tapi highlight
              : "bg-white text-gray-700 hover:bg-gray-100"
        }
      `}
    >
      <span className="text-sm font-semibold">
        {tab.label}
      </span>

      <span
        className={`text-xs px-2 py-0.5 rounded-full
          ${
            isActive
              ? "bg-white/20 text-white"
              : isSLA
                ? "bg-red-100 text-red-600"
                : "bg-gray-100 text-gray-600"
          }
        `}
      >
        {tab.count}
      </span>

      {/* 🔥 optional: indikator SLA */}
      {isSLA && (
        <span className={`text-xs ${isActive ? "text-white" : "text-red-500"}`}>
          ●
        </span>
      )}
    </button>
  );
})}

</div>

        {/* TABLE */}
        <div className="bg-white border rounded-2xl shadow-sm p-4">

          {/* SEARCH */}
         <div className="flex justify-between mb-3 items-center">
  
  <input
    className="border rounded-xl px-3 py-2 text-sm w-72"
    placeholder="Search order or customer..."
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />

  <div className="flex items-center gap-2">

    <div className="text-xs text-gray-500">
      {filteredData.length} Surat Jalan
    </div>

    {/* 🔥 BUTTON LAPORAN */}
    <button
      onClick={() => window.open("/warehouse/mutasi-masuk-laporan", "_blank")}
      className="px-3 py-2 text-sm bg-black text-white rounded-xl hover:bg-black transition"
    >
      Laporan Barang Masuk Mutasi
    </button>

  </div>
</div>

          {/* TABLE */}
          <DataTable
            columns={columns}
            data={filteredData}
                          progressPending={loading}
  progressComponent={<TableLoading />}
            pagination
            customStyles={customStyles}
            highlightOnHover
            persistTableHead
            
conditionalRowStyles={[
  {
    when: (row) => getSLAStatus(row) === "OVERDUE",
    style: {
      backgroundColor: "#fee2e2 !important",
      borderLeft: "4px solid #dc2626",
    },
  },
  {
    when: (row) => getSLAStatus(row) === "WARNING",
    style: {
      backgroundColor: "#ffedd5 !important",
      borderLeft: "4px solid #f97316",
    },
  },
]}
          />
        </div>
      </div>


{detailModal && (
  <div className="fixed inset-0 bg-black/60  backdrop-blur flex items-center justify-center z-[999999]">
     <div className="bg-white w-[600px] rounded-2xl p-6 shadow-xl">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-4 sticky top-0 bg-white py-2">
       <div>
  <h2 className="text-lg font-bold">
    Surat Jalan Mutasi Masuk Detail
  </h2>

  {/* ORDER ID INFO */}
  <div className="text-xs text-gray-500 mt-1">
     ID Mutasi Toko:{" "}
    <span className="font-medium text-gray-700">
      {orderDetail?.[0]?.id_mutasi_toko || "-"}
    </span>
  </div>
</div>

        <button
          onClick={() => setDetailModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>

        
      </div>

      {/* CONTENT */}
      {/* CONTENT */}
{loadingDetail ? (
 
  <div className="space-y-3">
    {[1,2,3,4,5].map((i) => (
      <div key={i} className="flex gap-3 animate-pulse">
        <div className="w-14 h-14 bg-gray-200 rounded-xl"></div>

        <div className="flex-1 space-y-2">
          <div className="h-3 w-40 bg-gray-200 rounded"></div>
          <div className="h-3 w-24 bg-gray-200 rounded"></div>
          <div className="h-3 w-32 bg-gray-200 rounded"></div>
        </div>
      </div>
    ))}
  </div>

) : (
  <>
    {/* TOP ACTION */}
   {/* TOP ACTION */}

   {isBelumPosting && (
  <div className="mb-3 p-3 rounded-xl bg-yellow-50 border border-yellow-200 text-xs text-gray-700 leading-relaxed flex gap-2">

    {/* ICON SIMPLE */}
    <div className="text-yellow-600 mt-0.5">
      ⚠
    </div>

    <div>
      <div className="font-medium text-gray-800 mb-1">
        Belum Posting
      </div>

      <div>
        Quantity per artikel & size harus sesuai hasil counting manual.
        Jika tidak menggunakan scan inbound uniq ID, pastikan semua item sudah dihitung ulang sebelum posting.
      </div>
    </div>

  </div>
)}
{isBelumPosting && (
  <div className="flex items-center justify-between mb-3">

    {/* CHECK ALL */}
    <label className="flex items-center gap-2 text-sm">
      <input
        type="checkbox"
        checked={
          orderDetail.length > 0 &&
          selectedItems.length === orderDetail.length
        }
        onChange={toggleAll}
      />

      Pilih Semua
    </label>

    {/* GROUP MODE */}
    <select
      value={groupMode}
      onChange={(e) => setGroupMode(e.target.value)}
      className="border rounded-lg px-3 py-1 text-sm"
    >
      <option value="uniq">
        View By Uniq ID
      </option>

      <option value="group">
        Group By SKU + Size
      </option>
    </select>
  </div>
)}

    <div className="space-y-3 max-h-[400px] overflow-auto">

      {/* ========================= */}
      {/* VIEW UNIQ */}
      {/* ========================= */}
      {groupMode === "uniq" &&
        orderDetail.map((item) => (
          <div
            key={item.uniq_id}
            className="border rounded-xl p-3 flex gap-3 items-start"
          >
            {/* CHECKBOX */}
            {/* CHECKBOX */}
{isBelumPosting && (
  <input
    type="checkbox"
    checked={selectedItems.includes(item.uniq_id)}
    onChange={() => toggleItem(item.uniq_id)}
    className="mt-1"
  />
)}

            <img
              src={item.photo}
              className="w-14 h-14 rounded-lg object-cover"
            />

            <div className="flex-1">
              <div className="font-medium text-sm">
                {item.uniq_id}
              </div>

              <div className="flex items-center justify-between mt-1 gap-2">
  <div
    className={`text-xs font-medium ${
      isValidSku(item.kode_extend)
        ? "text-gray-500"
        : "text-red-600"
    }`}
  >
    SKU: {item.kode_extend || "-"} -{" "}
    {item.ukuran || "-"}
  </div>

  <div className="text-xs font-bold bg-gray-100 px-3 py-1 rounded-lg whitespace-nowrap">
    Qty: {item.qty}
  </div>
</div>

              <div className="text-sm font-semibold mt-1">
                Rp {item.hjp}
              </div>
            </div>
          </div>
        ))}

      {/* ========================= */}
      {/* GROUP VIEW */}
      {/* ========================= */}
      {groupMode === "group" &&
        groupedData.map((group, idx) => (
          <div
            key={idx}
            className="border rounded-xl p-4"
          >
            <div className="flex justify-between items-center">
              <div>
                <div className="font-semibold text-sm">
                  {group.kode_extend}
                </div>

                <div className="text-xs text-gray-500">
                  Size: {group.ukuran}
                </div>
              </div>

              <div className="text-sm font-bold bg-gray-100 px-3 py-1 rounded-lg">
                Qty: {group.qty}
              </div>
            </div>

            {/* LIST ITEM */}
           <div className="mt-3 space-y-2">
  {group.items.map((item) => (
    <label
      key={item.uniq_id}
      className="flex items-center gap-2 text-sm"
    >

      {isBelumPosting && (
        <input
          type="checkbox"
          checked={selectedItems.includes(
            item.uniq_id
          )}
          onChange={() =>
            toggleItem(item.uniq_id)
          }
        />
      )}

      {item.uniq_id}
    </label>
  ))}
</div>
          </div>
        ))}
    </div>
  </>
)}

     {/* FOOTER ACTION */}
<div className="mt-5 flex justify-end gap-2 border-t pt-4">

  <button
    onClick={() => setDetailModal(false)}
    className="px-4 py-2 text-sm bg-gray-200 rounded-lg hover:bg-gray-300"
  >
    Tutup
  </button>

 

</div>
      

    </div>
  </div>
)}

{uniqModal && scanItem && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">
    
    <div className="bg-white w-[420px] rounded-2xl p-5 shadow-xl space-y-4">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <div className="font-bold">Scan / Set Unique ID</div>
          <div className="text-xs text-gray-500">
            {scanItem.product_name}
          </div>
        </div>

        <button
          onClick={() => setUniqModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      {/* QR IMAGE PREVIEW */}
      <div className="flex justify-center">
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${scanItem.unique_id || scanItem.line_item_id}`}
          className="w-40 h-40 border rounded-xl"
        />
      </div>

      {/* INFO */}
      <div className="text-center text-xs text-gray-500">
        Scan QR tag pada barang atau masukkan manual ID
      </div>

      {/* INPUT MANUAL */}
      <input
        value={uniqInput}
        onChange={(e) => setUniqInput(e.target.value)}
        placeholder="Masukkan / Scan Unique ID"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* ACTION */}
      <div className="flex gap-2 justify-end">
        <button
          onClick={() => setUniqModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            axios.post("/api/tiktokshop/set-unique-id", {
              line_item_id: scanItem.line_item_id,
              unique_id: uniqInput,
            })
            .then(() => {
              showToast("Unique ID tersimpan", "success");

              setOrderDetail((prev) =>
                prev.map((d) =>
                  d.line_item_id === scanItem.line_item_id
                    ? { ...d, unique_id: uniqInput }
                    : d
                )
              );

              setUniqModal(false);
            })
            .catch(() => showToast("Gagal simpan ID", "error"));
          }}
          className="px-4 py-2 text-sm bg-purple-600 text-white rounded-xl"
        >
          Simpan
        </button>
      </div>

    </div>
  </div>
)}

{skuModal && skuItem && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">

    <div className="bg-white w-[450px] rounded-2xl p-5 space-y-4">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <div className="font-bold">Barcode SKU</div>
          <div className="text-xs text-gray-500">
            {skuItem.product_name}
          </div>
        </div>

        <button
          onClick={() => setSkuModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      {/* 🧾 BARCODE IMAGE */}
      <div className="flex flex-col items-center gap-2">
        <img
  src={`https://bwipjs-api.metafloor.com/?bcid=code128&text=${encodeURIComponent(
    skuItem.seller_sku || ""
  )}&scale=2&height=10&includetext`}
  alt="barcode"
  className="w-[220px] h-[80px] object-contain bg-white p-2 border rounded-lg"
/>

        <div className="text-xs text-gray-500">
          SKU: <span className="font-medium">{skuItem.seller_sku}</span>
        </div>
      </div>

      {/* INPUT MANUAL */}
      <input
        value={skuInput}
        onChange={(e) => setSkuInput(e.target.value)}
        placeholder="Edit SKU manual"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* ACTION */}
      <div className="flex justify-end gap-2">
        <button
          onClick={() => setSkuModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            axios.post("/api/tiktokshop/update-sku", {
              line_item_id: skuItem.line_item_id,
              seller_sku: skuInput,
            })
            .then(() => {
              showToast("SKU berhasil diupdate", "success");

              setOrderDetail((prev) =>
                prev.map((d) =>
                  d.line_item_id === skuItem.line_item_id
                    ? { ...d, seller_sku: skuInput }
                    : d
                )
              );

              setSkuModal(false);
            })
            .catch(() => showToast("Gagal update SKU", "error"));
          }}
          className="px-4 py-2 text-sm bg-yellow-500 text-white rounded-xl"
        >
          Simpan SKU
        </button>
      </div>

    </div>
  </div>
)}

{scanReceiveModal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999999] p-4 transition-all">
    <div className="bg-slate-50 w-[1100px] max-w-[95vw] h-[90vh] max-h-[850px] flex flex-col rounded-2xl shadow-2xl overflow-hidden border border-slate-200">
      
      {/* HEADER UTAMA */}
      <div className="bg-white border-b border-slate-200 px-6 py-4 flex justify-between items-center shrink-0">
        <div>
          <div className="flex items-center gap-3">
            <h3 className="font-bold text-xl text-slate-800">Scan Penerimaan Mutasi</h3>
            <span className="px-2.5 py-0.5 bg-indigo-50 text-indigo-700 text-xs font-semibold rounded-md border border-indigo-100">
              Direct Inbound
            </span>
          </div>
          <p className="text-xs text-slate-500 mt-0.5">{selectedRow?.id_mutasi_toko || selectedRow?.id_perintah_mutasi}</p>
        </div>
        <button
          onClick={() => setScanReceiveModal(false)}
          className="w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all text-lg"
        >
          ✕
        </button>
      </div>

      {/* BODY KONTEN UTAMA */}
      <div className="flex-1 overflow-hidden p-6 flex flex-col gap-5">
        
        {/* BARIS ATAS: INFO TOKO & RINGKASAN DATA CARD */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 shrink-0">
          
          {/* SISI KIRI: DATA TOKO ASAL */}
          <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-4 shadow-sm">
            <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center text-slate-600 font-bold text-lg">
              🏬
            </div>
            <div className="min-w-0 flex-1">
              <span className="block text-[10px] uppercase font-bold text-slate-400">Lokasi Asal Pengirim</span>
              <span className="block text-sm font-bold text-slate-700 truncate">{selectedRow?.toko_asal || selectedRow?.tujuan || "-"}</span>
            </div>
          </div>

          {/* SISI KANAN: RINGKASAN AKUMULASI */}
          <div className="xl:col-span-2 grid grid-cols-4 gap-3">
            <div className="bg-white border border-slate-200 rounded-xl p-3 shadow-sm text-center">
              <span className="text-[11px] font-medium text-slate-400 block">Total Target</span>
              <span className="text-xl font-bold text-slate-800 block mt-0.5">{scanSummary.total} <span className="text-xs font-normal text-slate-400">pcs</span></span>
            </div>
            <div className="bg-emerald-50/60 border border-emerald-100 rounded-xl p-3 shadow-sm text-center">
              <span className="text-[11px] font-semibold text-emerald-600 block">Sudah Scan</span>
              <span className="text-xl font-bold text-emerald-700 block mt-0.5">{scanSummary.scanned} <span className="text-xs font-normal text-emerald-400">pcs</span></span>
            </div>
            <div className="bg-amber-50/60 border border-amber-100 rounded-xl p-3 shadow-sm text-center">
              <span className="text-[11px] font-semibold text-amber-600 block">Sisa Pending</span>
              <span className="text-xl font-bold text-amber-700 block mt-0.5">{scanSummary.remaining} <span className="text-xs font-normal text-slate-400">pcs</span></span>
            </div>
            <div className={`border rounded-xl p-3 shadow-sm text-center flex flex-col justify-center ${
              scanSummary.remaining === 0 ? "bg-teal-50 border-teal-100" : "bg-rose-50 border-rose-100"
            }`}>
              <span className="text-[10px] font-bold uppercase text-slate-400 block">Kondisi</span>
              <span className={`text-xs font-bold block mt-1 ${
                scanSummary.remaining === 0 ? "text-teal-700" : "text-rose-700"
              }`}>
                {scanSummary.remaining === 0 ? "✓ SESUAI" : "⚠️ BELUM SESUAI"}
              </span>
            </div>
          </div>
        </div>

        {/* PROGRESS BAR SLIDER */}
        <div className="bg-white border border-slate-200 rounded-xl px-5 py-3 shadow-sm shrink-0">
          <div className="flex justify-between items-center text-xs font-semibold text-slate-600 mb-1.5">
            <span className="flex items-center gap-1.5">📊 Akurasi Progress Inbound</span>
            <span className="bg-slate-100 px-2 py-0.5 rounded text-slate-700">
              {Math.round(scanSummary.total > 0 ? (scanSummary.scanned / scanSummary.total) * 100 : 0)}%
            </span>
          </div>
          <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden shadow-inner">
            <div
              className="h-full bg-gradient-to-r from-emerald-400 to-teal-500 transition-all duration-500 ease-out rounded-full"
              style={{
                width: `${scanSummary.total > 0 ? Math.min((scanSummary.scanned / scanSummary.total) * 100, 100) : 0}%`,
              }}
            />
          </div>
        </div>

        {/* SPLIT LAYOUT UTAMA */}
        <div className="flex-1 flex gap-5 overflow-hidden min-h-0">
          
          {/* KOLOM KIRI: PANEL CONTROL INPUT & WARNING NOTE */}
          <div className="w-[340px] flex flex-col gap-4 shrink-0">
            
            {/* INPUT SCAN AREA */}
            <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm flex flex-col gap-2">
              <label className="text-xs font-bold uppercase text-slate-600 block">
                Fokus Kamera / Scanner Laser
              </label>
              <input
                ref={scanReceiveRef}
                value={scanReceiveInput}
                onChange={(e) => setScanReceiveInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const kode_toko = localStorage.getItem("kode_toko");
                    const id_sunfish = localStorage.getItem("id_sunfish");
                    const totalQty = Number(selectedRow?.qty || 0);
                    const receivedQty = Number(scanSummary?.scanned || 0);

                    if (receivedQty >= totalQty) {
                      showToast("Qty sudah terpenuhi, tidak bisa scan lagi", "error");
                      return;
                    }

                    const rawScan = scanReceiveInput.trim();
                    axios.post("/api/warehouse/scan-penerimaan-mutasi", {
                      id_mutasi_toko: selectedRow.id_mutasi_toko,
                      uniq_id: rawScan,
                      kode_toko,
                      id_sunfish
                    })
                    .then(() => {
                      showToast(`Barang ${scanReceiveInput} diterima`, "success");
                      setScanReceiveInput("");
                      fetchData();
                      fetchScanDetail(selectedRow.id_mutasi_toko);
                    })
                    .catch((err) => {
                      const message = err?.response?.data?.message;
                      if (message === "Qty sudah terpenuhi") showToast("Qty sudah terpenuhi, tidak bisa scan lagi", "error");
                      else if (message === "Barang sudah diterima") showToast("Barang ini sudah discan sebelumnya", "warning");
                      else if (message === "Barang tidak ditemukan") showToast("Barang tidak ditemukan", "error");
                      else showToast(message || "Terjadi kesalahan", "error");
                    });
                  }
                }}
                placeholder="Sentuh sini & mulai scan..."
                className="w-full border-2 border-slate-200 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-50/50 rounded-xl px-4 py-3.5 text-base font-semibold outline-none transition-all placeholder:text-slate-300 shadow-inner"
                autoFocus
              />
              <div className="text-[11px] text-slate-400 text-center mt-1">
                ⌨️ Tekan <kbd className="bg-slate-100 px-1 rounded text-slate-500 border">Enter</kbd> di keyboard untuk submit manual
              </div>
            </div>

            {/* BOX CATATAN PENTING OPERASIONAL */}
            <div className="bg-amber-50/50 border border-amber-100 rounded-2xl p-4 text-xs text-slate-600 flex-1 overflow-y-auto">
              <div className="font-bold text-amber-800 flex items-center gap-1.5 mb-2 text-sm">
                <span>⚠️</span> SOP Aturan Penerimaan
              </div>
              <ul className="space-y-2 list-none pl-0">
                <li className="flex gap-2">
                  <span className="text-amber-500 font-bold">•</span>
                  <span>Jika fisik barang tidak sesuai manifes, wajib <b>Konfirmasi Toko Asal</b> sebelum posting.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-amber-500 font-bold">•</span>
                  <span>Setiap tembakan barcode langsung menambah stok terikat <b>Inbound Mutasi</b> toko Anda.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-amber-500 font-bold">•</span>
                  <span>Hindari menumpuk barcode di memori scanner untuk mencegah bentrok selisih data inventory.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* KOLOM KANAN: LIST ARTIKEL DATA DETAIL */}
          <div className="flex-1 bg-white border border-slate-200 rounded-2xl shadow-sm flex flex-col overflow-hidden min-w-0">
            
            {/* HEADER GRID BARIS */}
            <div className="grid grid-cols-12 bg-slate-50 border-b border-slate-200 px-4 py-3 text-xs font-bold text-slate-500 uppercase tracking-wider shrink-0">
              <div className="col-span-2">Visual</div>
              <div className="col-span-4">Identitas Produk</div>
              <div className="col-span-3 text-center">Ukuran & Qty</div>
              <div className="col-span-3 text-center">Aksi</div>
            </div>

            {/* CONTAINER SCROLL DATA ARTIKEL */}
            <div className="flex-1 overflow-y-auto divide-y divide-slate-100 min-h-0">
              {scanResult.length === 0 ? (
                <div className="h-full flex flex-col items-center justify-center p-8 text-slate-400 gap-2">
                  <span className="text-3xl">📦</span>
                  <p className="text-sm font-medium">Belum ada item yang masuk antrean scan.</p>
                </div>
              ) : (
                scanResult.map((item, idx) => (
                  <div
                    key={idx}
                    className="grid grid-cols-12 items-center px-4 py-3 text-sm hover:bg-slate-50/80 transition-all duration-150"
                  >
                    {/* 1. GAMBAR FOTO PRODUK */}
                    <div className="col-span-2">
                      <img
                        src={item.photo || `https://asset-3s.3second.co.id/product/${item.kode_extend}_1.JPG`}
                        alt={item.kode_extend}
                        className="w-12 h-12 object-cover rounded-lg border border-slate-200 bg-slate-50 shadow-sm"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "https://placehold.co/100x100/f1f5f9/94a3b8?text=No+Image";
                        }}
                      />
                    </div>

                    {/* 2. IDENTITAS DETAIL PRODUK */}
                    <div className="col-span-4 min-w-0 pr-2">
                      <span className="block font-bold text-slate-800 truncate text-sm">
                        {item.kode_extend}
                      </span>
                      <span className="block text-[11px] text-slate-400 mt-0.5 truncate" title={item.uniq_id}>
                        ID: {item.uniq_id}
                      </span>
                    </div>

                    {/* 3. SIZE & JUMLAH QUANTITY BERJALAN */}
                    <div className="col-span-3 text-center">
                      <span className="inline-block px-2 py-0.5 bg-slate-100 text-slate-700 font-bold text-xs rounded border border-slate-200 mb-1">
                        Size {item.ukuran || "FR"}
                      </span>
                      <div className="text-xs font-medium text-slate-500">
                        Total: <b className="text-slate-700 font-bold">{item.qty_received || 1}</b> / {item.qty || 1} pcs
                      </div>
                    </div>

                    {/* 4. TOMBOL AKSI KEMBALIKAN TOKO ASAL */}
                  {/* Tombol Aksi di Kolom 4 Modal */}
<div className="col-span-3 flex justify-center">
  {/* Kondisi: Hanya muncul jika item BELUM sukses di-scan sepenuhnya */}
  {!item.is_scanned && (
    <button
      // 1. Cek apakah item ini sedang dalam proses loading
      onClick={() => !isLoadingReturn && handleReturnToOrigin(item)} 
      disabled={isLoadingReturn} // Mengunci tombol agar tidak bisa diklik sama sekali
      className={`inline-flex items-center justify-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold rounded-lg shadow-sm transition-all
        ${isLoadingReturn 
          ? "bg-slate-100 text-slate-400 border border-slate-200 cursor-not-allowed" // UI saat Loading
          : "bg-orange-50 hover:bg-orange-600 text-orange-600 hover:text-white border border-orange-200 hover:border-orange-600 active:scale-95" // UI Normal
        }`}
      title={isLoadingReturn ? "Mohon tunggu, sedang memproses..." : "Kembalikan barang ini ke toko asal"}
    >
      {isLoadingReturn ? (
        /* 2. SPINNER ANIMASI SAAT LOADING */
        <svg className="animate-spin h-3.5 w-3.5 text-slate-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        /* 3. IKON UNDO NORMAL */
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.3} stroke="currentColor" className="w-3.5 h-3.5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
        </svg>
      )}
      
      <span>{isLoadingReturn ? "Memproses..." : "Kembalikan"}</span>
    </button>
  )}

  {/* Jika sudah di-scan, tampilkan teks indikator centang hijau */}
  {item.is_scanned && (
    <span className="text-xs font-semibold text-emerald-600 flex items-center gap-1">
      ✓ Diterima
    </span>
  )}
</div>
                  </div>
                ))
              )}
            </div>
          </div>

        </div>
      </div>

      {/* FOOTER MODAL */}
      <div className="bg-white border-t border-slate-200 px-6 py-4 flex justify-end shrink-0">
        <button
          onClick={() => setScanReceiveModal(false)}
          className="px-5 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 font-semibold text-sm rounded-xl border border-slate-200 shadow-sm transition-all"
        >
          Selesai & Keluar
        </button>
      </div>

    </div>
  </div>
)}
    </PageWrapper>
  );
}